export const getDefaultHeaders = () => {
  const token = JSON.parse(localStorage.getItem('converse_authkey') || '{}');
  const workspace = JSON.parse(
    localStorage.getItem('converse:last_active_workspace') || '{}'
  );
  return {
    'X-CONVERSE-TOKEN': `${token}`,
    'X-CONVERSE-SPACE': `${workspace}`,
    'Content-Type': 'application/json',
  };
};

export const http = async (request: RequestInfo, config: any) => {
  return fetch(request, config);
};

export const getWorkspaceUUID = () =>
  JSON.parse(localStorage.getItem('converse:last_active_workspace') || '{}');
